import FundingProgramDetail from './FundingProgramDetail';

export default FundingProgramDetail;
